import "./Select.scss";
import cx from "classnames";

import { Dropdown } from "../";
import { ReactComponent as DeltaIcon } from "../../assets/images/arrow-gray.svg";
import { ReactComponent as CheckboxIcon } from "../../assets/images/checkbox.svg";

function Select({ placeholder, variant = "white", options = [], onChange, isAd = false, isCampaign = false, isMobile = false }) {
  const handleSelect = (obj) => {
    const newSelectValue = obj.selected
      ? options.filter(({ value, selected }) => value !== obj.value && selected)
      : options.filter(({ selected }) => selected).concat(obj);
    if (onChange) onChange(newSelectValue);
  };

  if (window.outerWidth < 768) variant = "gray"

  return (
    <div className={cx("Select", variant, { "Select--campaign": isCampaign })}>
      <Dropdown
        isAd={isAd}
        isCampaign={isCampaign}
        isMobile={isMobile}
        button={
          <div className="select">
            {options.every((el) => !el.selected) && (
              <div className="placeholder-value">
                <div className="placeholder">{placeholder}</div>
                <DeltaIcon />
              </div>
            )}
            {(() => {
              const selectedOptions = options.filter((el) => el.selected);
              const allOption = selectedOptions.find(opt => 
                opt.value === "all_goals" || opt.value === "all_campaigns" || opt.value === "all_ads"
              );
              
              if (allOption) {
                return <span>{allOption.label}</span>;
              }
              
              return selectedOptions.map((obj, index, arr) => 
                <span key={index}>
                  {obj.label}
                  {index + 1 !== arr.length && ","}
                </span>
              );
            })()}
          </div>
        }
      >
        {options.map((obj, index) => {
            return (
              <button
                key={index}
                type="button"
                onClick={() => handleSelect(obj)}
              >
                {obj.selected !== null && <span
                  className={cx("rectangle", {
                    selected: obj.selected,
                  })}
                >
                   <CheckboxIcon
                    className={cx("rectangle-icon", {
                      selected: "rectangle-icon__visible",
                    })}
                  />
                </span>}
                {
                  obj.ad ? (
                    <div style={{ display: "flex", gap: 10, maxWidth: 300 }}>
                      {!!obj.ad?.banners?.length && (
                        obj.ad.banners[0]?.extension && obj.ad.banners[0].extension.toLowerCase() === "mp4" ? (
                          <video
                            style={{
                              width: "50px",
                              height: "100%",
                              objectFit: "contain",
                            }}
                            src={obj.ad.banners[0]?.url}
                            muted
                            controls
                          />
                        ) : (
                          <img
                            style={{
                              width: "50px",
                              height: "100%",
                              objectFit: "contain",
                            }}
                            src={obj.ad.banners[0]?.url}
                            alt="banner"
                          />
                        )
                      )}
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p style={{ fontSize: 15, margin: 0 }}>{obj.ad.head}</p>
                        <p
                          style={{
                            fontSize: 14,
                            opacity: "80%",
                            maxWidth: 200,
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            margin: 0,
                          }}
                        >
                          {obj.ad.text}
                        </p>
                      </div>
                    </div>
                  ) : (
                    obj.label
                  )
                }
              </button>
            );
          })}
      </Dropdown>
    </div>
  );
}

export default Select;

